<template>
    <div class="ysRegister">
        <div class="contain">
            <!-- <div class="title">医师注册</div> -->
            <div class="title"></div>
            <div class="register-form">
                <el-form ref="form" :model="form" label-width="120px" :rules="rules">
                            <el-row :span="24">
                                <el-col :span="12">
                                    <el-form-item label="经办人姓名：" prop="name">
                                        <el-input
                                            size="small"
                                            v-model="form.name"
                                            maxlength="20"
                                            show-word-limit
                                            placeholder="请输入经办人姓名"
                                            :disabled="displayNone1"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="经办人手机号:" prop="phone">
                                        <el-input
                                            size="small"
                                            v-model="form.phone"
                                            placeholder="请输入手机号..."
                                            :disabled="displayNone1"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                           <el-row>
                            <el-col :span="12">
                                <el-form-item label="经营场所名称：" prop="businessName">
                                    <el-input
                                        size="small"
                                        v-model="form.businessName"
                                        maxlength="20"
                                        show-word-limit
                                        placeholder="请输入经营场所名称"
                                        :disabled="displayNone1"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                label="经营地址："
                                class="input3"
                                prop="region"
                            >
                            <el-cascader
                                v-model="form.regionArr"
                                :props="{ value: 'regionCode', label: 'regionName' }"
                                :options="addressLists"
                                @change="handleChange"
                                 ref="cascader"
                                placeholder="请选择省/市/区/街道"></el-cascader>
                                
                            </el-form-item>
                            </el-col>
                           </el-row>
                           <el-row>
                            <el-col :span="24">
                                <el-form-item label="详细地址：" prop="address">
                                    <el-input
                                        type="textarea"
                                        :rows="3"
                                        placeholder="精确到门牌号/房间号"
                                        v-model="form.address">
                                        </el-input>
                                </el-form-item>
                            </el-col>
                           </el-row>
                           <el-row>
                            <el-col :span="12">
                                <el-form-item label="批发商类型:" prop="userMerchantType">
                                    <el-select
                                        size="small"
                                        v-model="form.userMerchantType"
                                        filterable
                                        clearable
                                        placeholder="请选择批发商类型"
                                        style="width:100%"
                                    >
                                        <el-option
                                            v-for="item of actions"
                                            :key="item.code"
                                            :value="item.code"
                                            :label="item.desc"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                           <div class="tips">
                           <p>说明：有效证件必须在有效期内</p> 
                           <p>中医诊所：上传营业执照、中医备案证、经办人身份证、经办人授权书</p>
                           <p>乡村诊所：上传药品经营许可证或医疗机构执业许可证、医师证、身份证</p>
                           <p>中医药店：上传营业执照、药品经营许可证、经办人身份证、经办人授权书</p>
                           </div>
                            <el-form-item
                                label="上传身份证:"
                                class="set-line-height-zero"
                                ref="portraitFaceImg"
                                 prop="portraitFaceImg"
                            >
                                <div class="upload-wrap fl">
                                    <el-upload
                                        :show-file-list="false"
                                        class="avatar-uploader"
                                        :action="myFileUrl+'minio/upload'"
                                        :on-remove="(file, fileList) => handleRemove2(file, fileList, 'portraitFaceImg')"
                                        :on-success="(res, file) => handleAvatarSuccess(res, file, 'portraitFaceImg')"
                                        :before-upload="beforeAvatarUpload"
                                    >
                                        <img
                                            v-if="form.portraitFaceImg"
                                            :src="$store.state.imgUrl+form.portraitFaceImg"
                                            class="avatar"
                                        />
                                        <img v-else :src="require('@/assets/img/sz.png')" alt />
                                    </el-upload>
                                </div>
                            </el-form-item>
                            <el-form-item
                                ref="nationalEmblemImg"
                                 prop="nationalEmblemImg"
                                class="set-line-height-zero marginLeft0"
                            >
                                <div class="upload-wrap fl">
                                    <el-upload
                                        :show-file-list="false"
                                        class="avatar-uploader"
                                         :action="myFileUrl+'minio/upload'"
                                         :on-remove="(file, fileList) => handleRemove2(file, fileList, 'nationalEmblemImg')"
                                        :on-success="(res, file) => handleAvatarSuccess(res, file, 'nationalEmblemImg')"
                                        :before-upload="beforeAvatarUpload"
                                    >
                                        <img
                                            v-if="form.nationalEmblemImg"
                                            :src=" $store.state.imgUrl+form.nationalEmblemImg"
                                            class="avatar"
                                        />
                                        <img v-else :src="require('@/assets/img/sf.png')" alt />
                                    </el-upload>
                                </div>
                            </el-form-item>
                            <el-row>
                                <el-form-item
                                label="营业执照:"
                                class="set-line-height-zero"
                                ref="businessLicenseImg"
                            >
                                <div class="upload-wrap fl">
                                    <el-upload
                                        :show-file-list="false"
                                        class="avatar-uploader"
                                        :action="myFileUrl+'minio/upload'"
                                        :on-remove="(file, fileList) => handleRemove2(file, fileList, 'businessLicenseImg')"
                                        :on-success="(res, file) => handleAvatarSuccess(res, file, 'businessLicenseImg')"
                                        :before-upload="beforeAvatarUpload"
                                    >
                                        <img
                                            v-if="form.businessLicenseImg"
                                            :src="$store.state.imgUrl+form.businessLicenseImg"
                                            class="avatar"
                                        />
                                        <img v-else class="add2" :src="require('@/assets/img/bgadd.png')" alt />
                                    </el-upload>
                                </div>
                                </el-form-item>
                                <el-form-item class="set-line-height-zero marginLeft0">
                                    <div class="upload-wrap fl">
                                        <img :src="require('@/assets/img/image.png')" alt />
                                    </div>
                                </el-form-item>
                            </el-row>
                            <el-form-item
                            label="药品经营许可证:"
                            class="set-line-height-zero"
                            ref="medicineLicenseImg"
                        >
                            <div class="upload-wrap fl">
                                <el-upload
                                    :show-file-list="false"
                                    class="avatar-uploader"
                                    :action="myFileUrl+'minio/upload'"
                                    :on-remove="(file, fileList) => handleRemove2(file, fileList, 'medicineLicenseImg')"
                                    :on-success="(res, file) => handleAvatarSuccess(res, file, 'medicineLicenseImg')"
                                    :before-upload="beforeAvatarUpload"
                                >
                                    <img
                                        v-if="form.medicineLicenseImg"
                                        :src="$store.state.imgUrl+form.medicineLicenseImg"
                                        class="avatar"
                                    />
                                    <img v-else class="add2" :src="require('@/assets/img/bgadd.png')" alt />
                                </el-upload>
                            </div>
                        </el-form-item>
                        <el-form-item class="set-line-height-zero marginLeft0">
                            <div class="upload-wrap fl">
                                <img :src="require('@/assets/img/image15.png')" alt />
                            </div>
                        </el-form-item>
                        <el-form-item
                        label="医疗机构执业许可证:"
                        class="set-line-height-zero"
                        ref="medicalInstitutionImg"
                    >
                        <div class="upload-wrap fl">
                            <el-upload
                                :show-file-list="false"
                                class="avatar-uploader"
                                :action="myFileUrl+'minio/upload'"
                                 :on-remove="(file, fileList) => handleRemove2(file, fileList, 'medicalInstitutionImg')"
                                :on-success="(res, file) => handleAvatarSuccess(res, file, 'medicalInstitutionImg')"
                                :before-upload="beforeAvatarUpload"
                            >
                                <img
                                    v-if="form.medicalInstitutionImg"
                                    :src="$store.state.imgUrl+form.medicalInstitutionImg"
                                    class="avatar"
                                />
                                <img v-else class="add2" :src="require('@/assets/img/bgadd.png')" alt />
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item class="set-line-height-zero marginLeft0">
                        <div class="upload-wrap fl">
                            <img :src="require('@/assets/img/image17.png')" alt />
                        </div>
                    </el-form-item>
                    <el-form-item
                    label="中医备案证:"
                    class="set-line-height-zero"
                    ref="zhongyiCertificateImg"
                >
                    <div class="upload-wrap fl">
                        <el-upload
                            :show-file-list="false"
                            class="avatar-uploader"
                           :action="myFileUrl+'minio/upload'"
                            :on-remove="(file, fileList) => handleRemove2(file, fileList, 'zhongyiCertificateImg')"
                            :on-success="(res, file) => handleAvatarSuccess(res, file, 'zhongyiCertificateImg')"
                            :before-upload="beforeAvatarUpload"
                        >
                            <img
                                v-if="form.zhongyiCertificateImg"
                                :src="$store.state.imgUrl+form.zhongyiCertificateImg"
                                class="avatar"
                            />
                            <img v-else class="add2" :src="require('@/assets/img/bgadd.png')" alt />
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item class="set-line-height-zero marginLeft0">
                    <div class="upload-wrap fl">
                        <img :src="require('@/assets/img/image18.png')" alt />
                    </div>
                </el-form-item>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item
                                label="医师执业证书:"
                                class="set-line-height-zero"
                                ref="medicalPractitionerCertificateImg"
                            >
                                <div >
                                    <el-upload
                                         class="avatar-uploader"
                                          :action="myFileUrl+'minio/upload'"
                                          list-type="picture-card"
                                          :on-success="
                                            (res, file) => handleAvatarSuccess2(res, file, 'medicalPractitionerCertificateImg')
                                          "
                                          :before-upload="file => beforeAvatarUpload2(file, 'medicalPractitionerCertificateImg')"
                                          :on-remove="
                                            (file, fileList) => handleRemove2(file, fileList, 'medicalPractitionerCertificateImg')
                                          "
                                          :file-list="medicalPractitionerCertificateImgArr"
                                          :limit="2"
                                          :on-change="
                                            (file, fileList) => handleEditChange2(file, fileList, 'medicalPractitionerCertificateImg')
                                          "
                                          :class="{hide:medicalPractitionerCertificateImgHide}"
                                         
                                        >
                                            <img
                                                class="add3"
                                                :src="require('@/assets/img/add2.png')"
                                                alt
                                            />
                                          <div slot="tip" class="el-upload__tip">最大1M；最多上传2张!</div>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item
                                label="授权书:"
                                class="set-line-height-zero"
                                ref="authorizationImg"
                            >
                                <div>
                                    <el-upload
                                         class="avatar-uploader"
                                          :action="myFileUrl+'minio/upload'"
                                          list-type="picture-card"
                                          :on-success="
                                            (res, file) => handleAvatarSuccess2(res, file, 'authorizationImg')
                                          "
                                          :before-upload="file => beforeAvatarUpload2(file, 'authorizationImg')"
                                          :on-remove="
                                            (file, fileList) => handleRemove2(file, fileList, 'authorizationImg')
                                          "
                                          :file-list="authorizationImgArr"
                                          :limit="5"
                                          :on-change="
                                            (file, fileList) => handleEditChange2(file, fileList, 'authorizationImg')
                                          "
                                          :class="{hide:authorizationImgHide}"
                                         
                                        >
                                            <img
                                                class="add3"
                                                :src="require('@/assets/img/add2.png')"
                                                alt
                                            />
                                          <div slot="tip" class="el-upload__tip">最大1M；最多上传5张!</div>
                                        </el-upload>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row class="text-center">
                        <el-col :span="24">
                            <el-form-item class="cancle-margin-left">
                                <el-button
                                    type="danger"
                                    @click="submitForm('form')"
                                    class="btn red"
                                >确 定</el-button>
                                <!-- <el-button type="danger" @click="resetForm()" class="btn red">取消</el-button> -->
                            </el-form-item>
                        </el-col>
                    </el-row>
                    
                </el-form>
            </div>
        </div>
        <el-dialog
            title="提示"
            :visible.sync="loginFlag"
            width="30%"
            center>
            <span>   更改信息提交成功！您需重新登录</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="goLogin">去登录</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "ysRegister",

    data() {
        const validatePhone = (rule, value, callback) => {
            const val = value.trim();
            if (val === "") {
                callback(new Error("请输入手机号"));
            } else if (!/^1\d{10}$/.test(val)) {
                callback(new Error("请输入正确的手机号"));
            } else {
                callback();
            }
        };
        return {
            medicalPractitionerCertificateImgArr:[],
            authorizationImgArr:[],
            addressLists:[],//存储省市区下拉列表数据
            cityCode:[],//选中的citycode
            cityTitle:[],//选中的cityname
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入经办人姓名",
                        trigger: "blur"
                    }
                ],
                phone: [
                    {
                        required: true,
                        validator: validatePhone,
                        trigger: "blur"
                    }
                ],
                businessName: [
                    {
                        required: true,
                        message: "请输入经办场所名称",
                        trigger: "blur"
                    }
                ],
                region: [
                    {
                        required: true,
                        message: "请选择经营地址",
                        trigger: "change"
                    }
                ],
                address: [
                    {
                        required: true,
                        message: "请输入详细地址",
                        trigger: "blur"
                    }
                ],
                userMerchantType: [
                    {
                        required: true,
                        message: "请选择批发商类型",
                        trigger: "change"
                    }
                ],
                portraitFaceImg: [
                    {
                        required: true,
                        message: "请上传身份证人像面照"
                    }
                ],
                nationalEmblemImg: [
                    {
                        required: true,
                        message: "请上传身份证国徽面照"
                    }
                ],
               
                businessLicenseImg: [
                    {
                        required: true,
                        message: "请上传营业执照"
                    }
                ],
                medicineLicenseImg: [
                    {
                        required: true,
                        message: "请上传药品经营许可证"
                    }
                ],
                medicalInstitutionImg: [
                    {
                        required: true,
                        message: "请上传医疗机构执业许可证"
                    }
                ],
                zhongyiCertificateImg: [
                    {
                        required: true,
                        message: "请上传中医备案证"
                    }
                ],
                medicalPractitionerCertificateImg: [
                    {
                        required: true,
                        message: "请上传医师执业证书"
                    }
                ],
                authorizationImg: [
                    {
                        required: true,
                        message: "请上传授权书"
                    }
                ]
            },
            form: {
                name:'',
                phone:'',
                businessName:'',
                regionArr:[], 
                region:'',
                regionCode:'',
                address:'',
                userMerchantType:'',
                businessLicenseImg:'',
                medicineLicenseImg:'',
                medicalInstitutionImg:'',
                zhongyiCertificateImg:"",
                medicalPractitionerCertificateImg:'',
                nationalEmblemImg:'',
                portraitFaceImg:'',
                authorizationImg:''
            },
            medicalPractitionerCertificateImgHide: false, //医师执业证书
            authorizationImgHide: false, // 授权书隐藏
            checked: true,
            centerDialogVisible: false,
            title: "",
            content: "",
            displayNone1: false, //不显示
            disabledEmail: false, //邮箱是否可编辑
            disabledCard: false ,//身份证是否可编辑
            actions:[],//批发商类型
            editFlag:false,//用于判断是否是编辑
            loginFlag:false,//去登陆弹窗
        };
    },
    methods: {
        //文件上传的格式判断
        beforeAvatarUpload(file) {
            const isLt1M = file.size / 1024 / 1024 < 1;
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            if (!isLt1M) {
                this.$message.error("上传图片大小不能超过 1MB!");
            }
            if (!isJPG && !isPNG) {
                this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
            }
            return (isJPG || isPNG) && isLt1M;
        },
        //上传成功
        handleAvatarSuccess(res, file, k) {
            let that = this;
            this.form[k] = res.data.bpath;
            if (res.code == 200) {
                that.$message.success("上传成功");
            } else {
                that.$message.error("上传失败");
            }
        },

        submitForm(formName) {
            let that = this;
            that.$refs[formName].validate(async valid => {
                if (!valid) return;
                if (that.form.userMerchantType == 1) {
					//中医诊所
					if (!that.form.businessLicenseImg) {
                        that.$message.error('请上传营业执照');
						return false
					}
					if (!that.form.zhongyiCertificateImg) {
						that.$message.error('请上传中医备案证');
						return false
					}
					if (!that.form.authorizationImg) {
						that.$message.error('请上传授权书');
						return false
					}
				} else if (that.form.userMerchantType == 2) {
					//乡村诊所
					if (!that.form.medicineLicenseImg) {
						that.$message.error('请上传药品经营许可证');
						return false
					}
					if (!that.form.medicalInstitutionImg) {
						that.$message.error('请上传医疗机构执业许可证证');
						return false
					}
					if (!that.form.medicalPractitionerCertificateImg) {
						that.$message.error('请上传医师执业证书');
						return false
					}
				} else if (that.form.userMerchantType == 3) {
					//中医药店
					if (!that.form.businessLicenseImg) {
						that.$message.error('请上传营业执照');
						return false
					}
					if (!that.form.medicineLicenseImg) {
						that.$message.error('请上传药品经营许可证');
						return false
					}
					if (!that.form.authorizationImg) {
						that.$message.error('请上传授权书');
						return false
					}
				} else if (that.form.userMerchantType == 9) {
					//其他
					if (!that.form.businessLicenseImg) {
						that.$message.error('请上传营业执照');
						return false
					}
					if (!that.form.medicalInstitutionImg) {
						that.$message.error('请上传医疗机构执业许可证');
						return false
					}
					if (!that.form.authorizationImg) {
						that.$message.error('请上传授权书');
						return false
					}
				}
                that.form.authorizationImg=that.form.authorizationImg.trim().replace(/^,|,$/g, '');//去除前后空格
                that.form.medicalPractitionerCertificateImg=that.form.medicalPractitionerCertificateImg.trim().replace(/^,|,$/g, '');//去除前后空格
             
                //注册医师
                let url = "/user/merchant/applyUserMerchant";
                that.$http
                    .post(url, that.form)
                    .then(res => {
                        res = res.data;
                        if (res.code == 200) {
                            if(that.editFlag){
                                this.loginFlag = true;
                                sessionStorage.clear();
                            }else{
                                that.$message({
                                    type: "success",
                                    message: "申请提交成功，管理员审核中..."
                                });
                                that.$router.replace({
                                    path: "/wholesalerInfo"
                                });
                            }
                           
                        } else {
                            that.$message.error(res.msg);
                        }
                    })
                    .catch(() => {
                    });
                    
            });
        },
        getAddressList(){
            var params = {};
            let url = "/city/getCityList";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    this.addressLists = res.data.data;
                }else{
                    that.$message(res.data.msg);
                }
            });
        },
        getType(){
            var params = {};
            let url = "user/merchant/getUserMerchantType";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    this.actions = res.data.data; 
                    this.form.userMerchantType = 1;
                }else{
                    that.$message(res.data.msg);
                }
            });
        },
        handleChange(value){
            // console.log(value,'e');
            this.form.regionCode = value.join();
            this.form.region = this.$refs["cascader"].getCheckedNodes()[0]?this.$refs["cascader"].getCheckedNodes()[0].pathLabels.join():'';
        },
    handleEditChange2(file, fileList, type) {
      let that = this;
    //   medicalPractitionerCertificateImgHide //医师执业证书
    //   authorizationImgHide // 授权书隐藏
      if (type == "medicalPractitionerCertificateImg") {
        that.medicalPractitionerCertificateImgHide = fileList.length >= 2;
      }
      if (type == "authorizationImg") {
        that.authorizationImgHide = fileList.length >= 5;
      }
    },
    /**
     * 文件上传之前之后参数说明file(单个文件流)为回调函数自带参数 type判断视频,图片,还是图片详情
     */
    beforeAvatarUpload2(file, type) {
        const allowedTypes = ['image/jpeg', 'image/png'];
        let isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!allowedTypes.includes(file.type)) {
            isJPG = false;
            this.$message.error('请上传正确格式图片');
            return false;
          }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 1MB!");
        }
        return isJPG && isLt2M;
    },
    /**
     * 文件上传成功之后参数说明 res(后台返回结果),file(单个文件流)为回调函数自带参数 type判断视频,图片,还是图片详情
     */
    handleAvatarSuccess2(res, file, type) {
      let that = this;
      if (res.code == 200) {
        // 为商品图片字段追加
        if (type == "medicalPractitionerCertificateImg") {
          this.form.medicalPractitionerCertificateImg===undefined?"":this.form.medicalPractitionerCertificateImg+=","+res.data.bpath;
          that.$refs["medicalPractitionerCertificateImg"].clearValidate();
        } else if (type == "authorizationImg") {
          this.form.authorizationImg===undefined?'':this.form.authorizationImg +=","+res.data.bpath;
          that.$refs["authorizationImg"].clearValidate();
        } 
        that.$message.success("上传成功");
      } else {
        that.$message.error("上传失败");
      }
    },
    /**
     * 移除文件参数说明 file,fileList为回调函数自带参数 type判断视频,图片,还是图片详情
     */
    handleRemove2(file, fileList, type) {
      let that = this;
      let prefix = that.$store.state.imgUrl;
      let fileUrl = [];
      var str = "";
      if (fileList.length > 0) {
        for (var i = 0; i < fileList.length; i++) {
          if(fileList[i].response){
            str= fileList[i].response.data.bpath;
          }else{
            str= fileList[i].url;
          }
          if (str.startsWith(prefix)) {
             //原始字符串包含指定前缀
              const remainingStr = str.slice(prefix.length);
              fileUrl.push(remainingStr);
            } else {
              //原始字符串不包含指定前缀
              fileUrl.push(str);
            }
        }
        if(type == "medicalPractitionerCertificateImg"){
            this.form.medicalPractitionerCertificateImg = fileUrl.join(",");
        }else if(type == "authorizationImg"){
            this.form.authorizationImg = fileUrl.join(",");
        }
       
      } else {
        if(type == "medicalPractitionerCertificateImg"){
            this.form.medicalPractitionerCertificateImg = "";
            that.medicalPractitionerCertificateImgHide = fileList.length >= 2;
        }else if(type == "authorizationImg"){
            this.form.authorizationImg = "";
            that.authorizationImgHide = fileList.length >= 5;
        }
      }
    },
    getData(){
        let that = this;
        let url = "/user/merchant/getUserMerchant";
        that.$http
            .post(url)
            .then(res => {
                res = res.data;
                if (res.code == 200) {
                    if(Object.keys(res.data).length === 0){
                        return false
                    }
                    that.form = res.data;
                    // 省市区
                    let regionCodeList =  that.form.regionCode.split(",");
                        //医师执业证书
                    let medicalPractitionerCertificateImgList =  that.form.medicalPractitionerCertificateImg.split(",");
                        //授权书
                    let authorizationImgList =  that.form.authorizationImg.split(",");
                    if(regionCodeList.length&&regionCodeList[0]){
                        that.form.regionArr = regionCodeList;
                    }
                    if(medicalPractitionerCertificateImgList.length&&medicalPractitionerCertificateImgList[0]){
                        for(let i=0;i<medicalPractitionerCertificateImgList.length;i++){
                            that.medicalPractitionerCertificateImgArr.push({ url:that.$store.state.imgUrl+medicalPractitionerCertificateImgList[i]});
                        }
                        that.medicalPractitionerCertificateImgHide = medicalPractitionerCertificateImgList.length >= 2;
                    }
                    if(authorizationImgList.length&&authorizationImgList[0]){
                        for(let j=0;j<authorizationImgList.length;j++){
                            that.authorizationImgArr.push( { url: that.$store.state.imgUrl+authorizationImgList[j]});
                            }
                            that.authorizationImgHide = authorizationImgList.length >= 5;
                    }
                    
                } else {
                    that.$message.error(res.msg);
                }
            })
            .catch(() => {
            });
        },
        goLogin(){
            let that = this;
            sessionStorage.clear();
            that.$router.replace({
                path: "/login"
            });
        }

    },
    created() {
        this.getAddressList();//获取省市区
        this.getType();//获取批发商类型
        this.getUserinfo();
        this.getData();
        if(this.$route.query.type=="edit"){
            this.editFlag = true;
        }else{
            this.editFlag = false;
        }
    }
};
</script>

<style scoped>
.add2{
    width: 100%!important;
    height: 100%!important;
} 
.add3{
    width: 30px!important;
    height: 30px!important;
} 
/deep/.hide .el-upload--picture-card {
    display: none!important;
}
.contain {
    width: 1024px;
    margin: 0 auto;
}
.ysRegister {
    background-color: #f8f8f8;
    padding-bottom: 100px;
}
.title {
    padding: 40px 0px 20px 0px;
}
.register-form {
    background-color: #fff;
    padding: 40px 120px 70px 90px;
}
.upload-wrap {
    width: 181px;
    height: 113px;
    border: 1px solid #d6d6d6;
    margin-right: 20px;
    display: flex;
    align-items: center;
    border-radius: 6px;
}
.avatar-uploader {
    margin: 0 auto;
}
/* .yszzp,
.avataryszzp {
    width: 120px;
    height: 140px;
} */
.avatar {
    width: 181px;
    height: 113px;
}
.el-upload img {
    vertical-align: middle;
}
.set-line-height-zero {
    display: inline-block;
}
.displayNoneClass {
    display: none;
}
.yszzp,
.avataryszzp {
    width: 120px;
    height: 140px;
}
.tips{
    margin-left: 20px;
    margin-bottom: 30px;
    color: #676767;
    font-size: 13px;
    
}
</style>
<style>
.marginLeft0 .el-form-item__content {
    margin-left: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/JW/wholesaler.vue